import { Component } from "@angular/core";
import { FormlyFieldRadio } from "@ngx-formly/bootstrap/radio";

@Component({
  selector: "astrobin-formly-field-custom-radio",
  templateUrl: "./formly-field-custom-radio.component.html"
})
export class FormlyFieldCustomRadioComponent extends FormlyFieldRadio {}
